import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  OnDestroy,
  ViewChild
} from '@angular/core';
import {IonicModule, ModalController} from "@ionic/angular";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {PaymentMethod} from "../../enums/PaymentMethod";
import {PAYMENT_SERVICE} from "../../api/api";
import {environment} from "../../../environments/environment";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-credit-card-modal',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    IonicModule
  ],
  templateUrl: './credit-card-modal.component.html',
  styleUrl: './credit-card-modal.component.scss'
})
export class CreditCardModalComponent implements AfterViewInit, OnDestroy {
  @ViewChild('formBlock', {static: false}) formBlock: ElementRef<HTMLElement>;

  vrUrl = environment.baseUrl + PAYMENT_SERVICE + 'vr/pay/';

  cardWidgetLoaded = false;
  name = this.route.snapshot.queryParamMap.get('name');
  @HostBinding('class.dark-menu')
  get darkMenu() {
    return !!this.name;
  }

  private formBlockResizeObserver: ResizeObserver;

  constructor(private modalCtrl: ModalController,
              private route: ActivatedRoute,
              private cdr: ChangeDetectorRef) {}

  ngAfterViewInit() {

    this.formBlockResizeObserver = new ResizeObserver((entries) => {
      if (entries[0].contentRect.height) {
        this.cardWidgetLoaded = true;
        this.cdr.detectChanges()
        this.formBlockResizeObserver?.disconnect();
      }
    });
    this.formBlockResizeObserver.observe(this.formBlock.nativeElement);
  }

  ngOnDestroy() {
    this.formBlockResizeObserver?.disconnect();
  }

  static async show(
      modalCtrl: ModalController
  ) {
    const modal = await modalCtrl.create({
      component: CreditCardModalComponent,
      cssClass: 'auto-height credit-card-modal',
      showBackdrop: true
    });

    await modal.present();
    return modal.onDidDismiss();
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  protected readonly pm = PaymentMethod;
}
